import React from 'react';
import FeedbackButton from './FeedbackButton';

// Mobile phone shell that expands into a desktop workspace at large breakpoints.
export default function PhoneFrame({ children, withNav = false }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center p-0 lg:p-6"
      style={{ background: 'radial-gradient(140% 120% at 50% -10%, #14162e 0%, #06070f 55%, #000 100%)' }}>
      <div className={`orbit-app-frame ${withNav ? 'orbit-app-frame--with-nav' : 'orbit-app-frame--focus'} relative overflow-hidden w-full`}>
        {/* Floating, not in the top-right header row -- every page already
            packs its own icon buttons (Search/Settings/Pencil/etc) into
            that corner, so a global overlay there collides with them. */}
        <div className="absolute z-20" style={{ bottom: withNav ? 92 : 18, right: 18 }}>
          <FeedbackButton />
        </div>
        <div className="orbit-frame-scroll relative h-full w-full orbit-scroll overflow-y-auto"
          style={{ paddingBottom: withNav ? 80 : 0 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
